/* eslint-disable */
import $ from 'jquery';

$('.close-newsletter').on('click', function (e) {
    e.preventDefault();
    $('.cta-newsletter-article').addClass('closed');
});

function checkRequireFieldsFilled(currentForm) {
    const requiredInputs = $(currentForm).find('input:required');
    if (requiredInputs) {
        let allFilled = true;
        requiredInputs.each(function(index, currentInput) {
            const $currentInput = $(currentInput);
            const currentType = $currentInput.attr('type');
            if (currentType === 'text') {
                if ($(currentInput).val() === '') {
                    allFilled = false;
                }
            } else if (currentType === 'checkbox') {
                if (!$(currentInput).prop('checked')) {
                    allFilled = false;
                }
            }
        });
        return allFilled;
    }
    return true;
}

function checkRequiredFields() {
    $('.services-project-form-container form').each(function (index, currentForm) {
        const isFilled = checkRequireFieldsFilled(currentForm);
        if (isFilled) {
            $(currentForm).find('._submit').removeAttr('disabled');
        } else {
            $(currentForm).find('._submit').attr('disabled', 'disabled');
        }
    });
}

checkRequiredFields();

$('.services-project-form-container form input[type=text], .services-project-form-container form textarea').on('input', function() {
    checkRequiredFields();
});

$('.services-project-form-container form input[type=checkbox]').on('change', function() {
    checkRequiredFields();
});
